import Activity, {ActivityAvailability} from "@/models/activity";
import WorkingHours from "@/models/workingHours";

export default class Party {
    public id?: number;
    public name?: string;
    public surname?: string;
    public type?: string;
    public email?: string;
    public mobile?: string;
    public login?: string;
    public dateFrom?: string;
    public dateTo?: string;
    public isDefault?: boolean;
    public activities?: Array<Activity>;
    public workingHours?: WorkingHours;
    public availability?: ActivityAvailability;

    constructor({
                    id,
                    name,
                    surname,
                    type,
                    email,
                    mobile,
                    login,
                    dateFrom,
                    dateTo,
                    isDefault,
                    activities,
                    workingHours,
                    availability
                }: any) {
        this.id = id;
        this.name = name;
        this.surname = surname;
        this.type = type;
        this.email = email;
        this.mobile = mobile;
        this.login = login;
        this.dateFrom = dateFrom;
        this.dateTo = dateTo;
        this.isDefault = isDefault;
        this.activities = activities;
        this.workingHours = workingHours ? workingHours : new WorkingHours({})
        this.availability = availability
    }
}

export class WriteParty {
    public id?: number;
    public name: string;
    public surname: string;
    public login: string;
    public password: string;
    public email: string;
    public mobile: string;
    public type: string;
    public activities: number[];
    public workingHours: WorkingHours;


    constructor({
                    id,
                    name,
                    surname,
                    login,
                    password,
                    email,
                    mobile,
                    type,
                    activities,
                    workingHours
                }: any) {
        this.id = id;
        this.name = name;
        this.surname = surname;
        this.login = login;
        this.password = password;
        this.email = email;
        this.mobile = mobile;
        this.type = type;
        this.activities = activities;
        this.workingHours = workingHours
    }
}
